import { getDeviceTransactionQueryParamsV2 } from '../../../../../../components/DeviceControl/queries';
import { isValidDCT } from '../../Entity/Reducers/EnitityControlReducer';
import { ConsumerDao } from '../../../../../../data/ConsumerDAO';
import { existsFilter } from '@iotv/core-services';
const debug = process.env.REACT_APP_DEBUG && false;
export const batchGetLatestDCTs = async ({ Entities, addDCTs, broadcastScheduleSk }) => {
    const batchSize = 10;
    const lastDCTsLimit = 100;
    const mutableEntities = Object.values(Entities);
    while (mutableEntities.length > 0) {
        const batch = mutableEntities.splice(0, batchSize);
        /** in line calls to addDCT, so done is just for a marker */
        const done = Promise.all(batch
            .map(async (entity) => {
            if (entity.deviceEuis instanceof Array) {
                if (entity.deviceEuis.length > 0) {
                    const euis = entity.deviceEuis;
                    return Promise.all(euis.map(async (eui) => {
                        const params = getDeviceTransactionQueryParamsV2({ deviceSk: `Device:${eui}`, Limit: lastDCTsLimit, broadcastScheduleSk });
                        debug && console.log(`batchGetLatestDCTs params for dcts`, params);
                        const { err, data } = await ConsumerDao.baseQuery(params);
                        if (err) {
                            console.log(`WARN: unhandled err in batchGetLatestDCTs`, err.message);
                        }
                        if (data) {
                            debug && console.log(`batchGetLatestDCTs prefilter dcts`, data.Items);
                            if (data.Items && data.Items.length > 0) {
                                const validDCTs = data.Items.filter(isValidDCT);
                                debug && console.log(`batchGetLatestDCTs valid dcts`, validDCTs);
                                addDCTs(entity, validDCTs);
                            }
                        }
                    }));
                }
                else
                    return null;
            }
            else
                return null;
        })
            .flat(2)
            .filter(existsFilter));
        await done;
    }
};
